import type { RouterConfig } from '@nuxt/schema'

export default <RouterConfig> {
  // https://router.vuejs.org/api/interfaces/routeroptions.html#routes
  routes: _routes => [
    {
      name: 'Home',
      path: '/',
      component: () => import('~/views/home/index.vue').then(r => r.default || r),
    },
    {
      name: 'Partner',
      path: '/partner',
      component: () => import('~/views/home/index.vue').then(r => r.default || r),
    },
    {
      name: 'Product',
      path: '/product',
      component: () => import('~/views/product/index.vue').then(r => r.default || r),
    },
    {
      name: 'Study',
      path: '/study',
      component: () => import('~/views/study/index.vue').then(r => r.default || r),
    },
    {
      name: 'NewList',
      path: '/new-list',
      component: () => import('~/views/new/newList.vue').then(r => r.default || r),
    },
    {
      name: 'NewInfo',
      path: '/new-info',
      component: () => import('~/views/new/newInfo.vue').then(r => r.default || r),
    },
    {
      name: 'About',
      path: '/about',
      component: () => import('~/views/about/index.vue').then(r => r.default || r),
    },
  ],
}
